// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__STr5P","loading":"Loading_loading__ye0xw"};